// @core/api/endpoints/apikey/delete_api_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/apikey';

/**
 * Delete API key
 * Permanently removes an API key, immediately revoking all access. This action cannot be undone. Any applications using this key will lose access.
 */
export async function DeleteAPIKey(
  key_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-keys/:key_id`;
  requestPath = requestPath.replace(':key_id', encodeURIComponent(key_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
